import { useEffect, useRef } from "react";

// Instagram official embed. Renders a <blockquote class="instagram-media"> for each URL
// and loads Instagram's embed.js to hydrate them. No API keys required.
export default function InstagramEmbed({ posts }) {
  const rootRef = useRef(null);

  useEffect(() => {
    // Inject script once
    const src = "https://www.instagram.com/embed.js";
    let script = document.querySelector(`script[src="${src}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    }
    // Trigger process
    const process = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };
    const t = setTimeout(process, 400);
    return () => clearTimeout(t);
  }, [posts]);

  if (!posts?.length) return null;

  return (
    <div ref={rootRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {posts.map((p) => (
        <div key={p.id} data-testid={`ig-embed-${p.id}`} className="min-w-0 rounded-2xl overflow-hidden bg-white border border-[#EDEDED]">
          <blockquote
            className="instagram-media"
            data-instgrm-captioned=""
            data-instgrm-permalink={p.url}
            data-instgrm-version="14"
            style={{
              background: "#FFF",
              border: 0,
              margin: 0,
              padding: 0,
              minWidth: "unset",
              width: "100%",
            }}
          >
            <a href={p.url} target="_blank" rel="noreferrer" className="block p-6 text-sm text-[#A0A0A0]">
              View this post on Instagram
            </a>
          </blockquote>
        </div>
      ))}
    </div>
  );
}
